module.exports = __webpack_public_path__ + "static/media/ic_share_white.a3903fc2.svg";